export default __webpack_public_path__ + "static/media/Transmision.3bf262f1.png";